module.exports = __webpack_public_path__ + "static/media/cows-bg.91ae2bd2.svg";